import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import AppContextProvider from './store/store';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

 <BrowserRouter>
  <AppContextProvider>
    <App />
    </AppContextProvider>
 </BrowserRouter>
);

